import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { GuestGuard } from './guards/guest/guest.guard';
import { LandingPagePage } from './pages/landing-page/landing-page.page';
import { ForgotPasswordPage } from './pages/user/forgot-password/forgot-password.page';
import { ResetPasswordPage } from './pages/user/reset-password/reset-password.page';
import { SignInPage } from './pages/user/signin/signIn.page';
import { SignUpPage } from './pages/user/signUp/signUp.page';
import { AdminSignInPage } from './pages/admin/signin/adminsignin.page';
import { ClientsInformationsComponent } from './pages/admin/clients-informations/clients-informations/clients-informations.component';
import { AccountantPageComponent } from './pages/accountant/accountant-page';
import { AccountantAuthenticationComponent } from './pages/accountant/authentication/accountant-authentication.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'landing-page'
  },
  {
    path: 'landing-page',
    component: LandingPagePage,
  },
  {
    path: 'sign-up',
    component: SignUpPage,
    title: 'register',
    canActivate: [
      GuestGuard
    ]
  },
  {
    path: 'sign-in',
    component: SignInPage,
    title: 'login',
    canActivate: [
      GuestGuard
    ]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPage,
    title: 'forgotpassword',
    canActivate: [
      GuestGuard
    ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordPage,
    title: 'resetpassword',
    canActivate: [
      GuestGuard
    ]
  },
  {
    path: 'admin',
    component: AdminSignInPage,
    title: 'admin'
  },
  {
    path: 'admin/client-informations',
    component: ClientsInformationsComponent
  },
  {
    path: 'contador',
    component: AccountantPageComponent,
    title: 'accountant'
  },
  {
    path: 'authentication',
    component: AccountantAuthenticationComponent,
    title: 'accountantAuthentication'
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '404',
    redirectTo: 'sign-in'
  },
  {
    path: '**',
    redirectTo: '/sign-in'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), BrowserModule],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
  exports: [RouterModule]
})
export class AppRoutingModule { }